<div class="our-success-stories-wrapper">
  <div class="main-title">
    {{info.title}}
  </div>
  <div class="slider-wrapper">
    <!-- <ngx-glide  [showArrows]="false" [gap]="10" [perView]="1" [showBullets]="false" [bound]="true" [listenToEvents]="true" (swipeEnded)="onSwipeEnded()"> -->
    <div class="swiper-container" [swiper]="config">
      <div class="swiper-wrapper">
        <div class="swiper-slide video-card" *ngFor="let video of info.videoList; index as i">
          <video preload height="100%" width="100%" playsinline>
            <source [src]="video.url" type="video/mp4">
            Your browser does not support html video tag
          </video>
          <div class="play-icon-wrapper">
            <img src="/assets/images/home-v2/play-icon-home.png" *ngIf="video.isPaused" alt="play icon button" (click)="playVideo($event, video)">
            <img src="/assets/images/home-v2/pause-icon-home.png" *ngIf="!video.isPaused" alt="pause icon button" (click)="playVideo($event, video)">
          </div>
        </div>
      </div>
    </div>
    <!-- </ngx-glide> -->
    <div class="social-icons-wrapper">
      <div class="content-wrapper">
        <ng-container *ngIf="!isMobile">
          <div class="title">{{info.socialContent.title}}</div>
          <div class="desc">{{info.socialContent.desc}}</div>
        </ng-container>
        <ng-container *ngIf="isMobile">
          <div class="content">
            <div class="title">{{info.socialContent.title}}</div>
            <div class="desc">{{info.socialContent.desc}}</div>
          </div>
          <div class="img-ketto">
            <img src="/assets/images/home-v2/ketto-logo-1.png" alt="our success ketto social" />
          </div>
        </ng-container>
      </div>
      <div class="social-icons">
        <button mat-button (click)="onSocialMediaClicked('ig')">
          <div class="img-wrapper">
            <img src="/assets/images/home-v2/ig-logo-ketto.png" alt="instagram logo" />
          </div>
          <div class="label">
            Instagram
          </div>
        </button>
        <button mat-button (click)="onSocialMediaClicked('fb')">
          <div class="img-wrapper">
            <img src="/assets/images/home-v2/fb-logo-ketto.png" alt="fb logo" />
          </div>
          <div class="label">
            Facebook
          </div>
        </button>
      </div>
    </div>
  </div>
</div>